/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./EditableTitle.vue?vue&type=template&id=22092fc4"
import script from "./EditableTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditableTitle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EditableTitle.vue?vue&type=style&index=0&id=22092fc4&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports